import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Task } from 'src/app/models/Task';
import { FileModel } from 'src/app/models/FileModel';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/delavci/main.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { timeParserOneElement } from 'src/app/utils/timeParserOneElement';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HelpdeskProcesses } from 'src/app/models/HelpdeskProcesses';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { DialogDodajDelavcaComponent } from '../dialog-dodaj-delavca/dialog-dodaj-delavca.component';
import { MessagesComponent } from './messages/messages.component';
import { RepositoryService } from 'src/app/services/repository.service';
import { PartnerData } from 'src/app/models/PartnerData';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-uredi-task',
  templateUrl: './uredi-task.component.html',
  styleUrls: ['./uredi-task.component.css']
})
export class UrediTaskComponent implements OnInit, OnChanges {

  public noDataAvailable = false;
  public text;
  public mailContent;
  public partnerLoggedIn = false;
  public files: File[] = [];
  public filesCount: number;
  public addFileShow = false;
  public tableData: Array<object>;
  public dataRow: Task;

  public displayedColumns: string[] = ['position', 'name'];
  public dataSourceLeft;
  public dataSourceRight;

  public returnedQueryParams = [];
  public fileArray: Array<FileModel> = [];
  public spentMinutes;
  public TODOupdate;
  public spinner = false;
  public hideNavSelected = false;
  public flexSizeNavbar = "216px";
  public rowDataBasic;
  public rowDataPartner;
  public param_idTask;
  public isMobile;
  public communicationIdChat;
  public showFilter;
  public queryParamZavihek;
  public workerUser;
  public partners: string[];
  public partnersAll: PartnerData[];
  public partnerTitleSmallFilter = new UntypedFormControl();
  public suggestions: string[] = [];
  public showSuggestions: boolean = false;
  public selectedPartner: PartnerData;
  public filteredSuggestions;
  @ViewChild(MessagesComponent, { static: false }) messageViewChild: MessagesComponent;
  constructor(private helpdeskService: HelpdeskService, private loginPartnerService: LoginPartnerService,
    private router: Router, private mainService: MainService, private cd: ChangeDetectorRef, private route: ActivatedRoute,
    private _snackbar: MatSnackBar, private deviceService: DeviceDetectorService, private helperService: HelpersService,
    private dialog: MatDialog, private repositoryService: RepositoryService) {
    router.events.subscribe(() => {
      this.route.queryParams.subscribe(params => {
        this.queryParamZavihek = params['zavihek'];
      });
    });

    this.returnedQueryParams.push("Lumina POS");
    this.returnedQueryParams.push("babyDatabase");
    this.returnedQueryParams.push("721");
    this.returnedQueryParams.push("937");

  }

  ngOnInit() {
    this.spinner = true;
  
    // Check if a regular user or partner is logged in
    if (this.mainService.currentUserValue || this.loginPartnerService.currentPartnerValue) {
      const sessionUser = this.mainService.currentUserValue 
        ? this.mainService.currentUserValue.sessionUser
        : this.loginPartnerService.currentSessionValue;
  
        this.helpdeskService.getPartners(sessionUser).subscribe(data => {
          this.partners = data.data.partners.map((partner) => partner.nameSmall);
          this.partnersAll = data.data.partners; // Ensure partnersAll is populated here
          this.spinner = false;
      }, error => {
          console.error(error);
          this.spinner = false;
      });
  
      this.filterPartners();
      this.workerUser = this.mainService.currentUserValue || this.loginPartnerService.currentPartnerValue;
  
      // Other initializations that depend on the user being logged in
      // ...
    } else {
      // Logic for when no user or partner is logged in
      this.spinner = false;
    }
  
    this.isMobile = this.deviceService.isMobile();
    this.mailContent = null;
  
    // Subscriptions that do not depend on a user being logged in
    this.helpdeskService.urediHelpdeskFilterBool.subscribe(bool => {
      this.showFilter = bool;
    });
  
    this.helpdeskService.currentDataRow.subscribe(task => {
      this.dataRow = task;
      if (this.dataRow) {
        this.setData();
        this.webServiceCalls();
      } else {
        this.spinner = false;
      }
    }, error => {
      console.log(error);
      this.spinner = false;
    });
  
    this.helpdeskService.currentHelpdeskParameters.subscribe(data => {
      this.communicationIdChat = data.communicationIdChat;
    });
  }
  


  public filterPartners() {
    this.partnerTitleSmallFilter.valueChanges
      .subscribe(partnerTitleSmall => {
        if (!Array.isArray(this.partnersAll)) {
          console.error("this.partnersAll is not initialized as an array.");
          return;
        }

        this.filteredSuggestions = this.partnersAll.filter(partner =>
          partner.nameSmall.toLowerCase().startsWith(partnerTitleSmall.toLowerCase())
        );
      });
    console.log(this.filteredSuggestions);
  }

  public onSuggestionSelected(selectedValue: string) {
    // Find the selected partner object based on nameSmall
    const selectedPartner = this.partnersAll.find(partner => partner.nameSmall === selectedValue);
    if (selectedPartner) {
      this.selectedPartner = selectedPartner;
      console.log('Selected Partner:', `nameSmall: ${selectedPartner.nameSmall}, contactId: ${selectedPartner.contactId}`);

    }
  }
  private getDistinctPartnerCodes(data: PartnerData[]): string[] {
    const distinctPartnerCodes: Set<string> = new Set();
    data.forEach((item) => {
      distinctPartnerCodes.add(item.nameSmall);
    });
    return Array.from(distinctPartnerCodes);
  }

  checkIfHelpdeskProcessExists() {
    this.spinner = true;
    this.helpdeskService.getHelpdeskProcess(this.mainService.currentUserValue, this.dataRow.id).subscribe(data => {
      let arrayProcesses: Array<HelpdeskProcesses> = [];
      let notesText;
      arrayProcesses[0] = data.data;
      notesText = arrayProcesses[0].note;
      if (arrayProcesses[0].processCode === null) { //Tu bi lahko bil boljši validation, samo iz WS-ja dobim samo null vrednosti.
        this.processesSelected();
      } else {
        this.descriptionSelected();
      }
      this.spinner = false;
    }, error => {
      console.log(error);
      this.spinner = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.router.url);
  }
  webServiceMailCall() {
    this.spinner = true;
    this.helpdeskService.getHelpDeskMailContent(this.loginPartnerService.currentSessionValue,
      this.mainService.currentUserValue, this.dataRow.id).subscribe(data => {
        if (data.data.mailContent) {
          this.mailContent = data.data.mailContent.toString();
          this.mailContent = (this.mailContent.substr(this.mailContent.indexOf('<'), this.mailContent.length)
          );
        }
        this.spinner = false;
      }, error => {
        console.log(error);
        this.spinner = false;
      });
  }

  webServiceCalls() {
    this.spinner = true;

    this.helpdeskService.getHelpDeskFiles(this.loginPartnerService.currentSessionValue,
      this.mainService.currentUserValue, this.loginPartnerService.currentPartnerValue, this.dataRow.id)
      .subscribe(data => {
        if (data && data.data && data.data.files && data.data.files.length > 0) {
          this.fileArray = data.data.files.map(file => {
            let newFile: FileModel = new FileModel();
            newFile.filename = file.name;
            newFile.path = file.path;
            newFile.id = file.id;
            return newFile;
          });
          this.noDataAvailable = false;
        } else {
          this.fileArray = [];
          this.noDataAvailable = true;
        }
        this.spinner = false;
      }, error => {
        console.log(error);
        this.spinner = false;
      });
  }


  private showMessageNoData() {
    this._snackbar.open('No files available for this task.', '', { duration: 3000 });
  }


  onFileSubmitted() {
    this.spinner = true;
    for (let item of this.files) {
      this.helpdeskService.postFile(item).subscribe(data => {
        const file: FileModel = data;
        this.helpdeskService.setFileToTask(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
          this.dataRow.id, 'INSERT', 'CODE_PARTNER.CONTACTDIARY', null, file.filename, file.path, null, null).subscribe(data => {
            this.webServiceCalls();
            this.files = [];
            this.filesCount = 0;
            this.spinner = false;
          }, error => {
            console.log(error);
            this.spinner = false;
          });
      }, error => {
        console.log(error);
      });
    }
  }

  onUpdateFiles(event: boolean) {
    if (event) {
      this.webServiceCalls();
    }
  }


  onTicketSubmit() {
    let timeSpent = this.spentMinutes * 60000;
    this.helpdeskService.setTaskUpdate(this.loginPartnerService.currentSessionValue, this.loginPartnerService.currentPartnerValue,
      this.mainService.currentUserValue, this.text, this.dataRow.id, null, timeSpent, this.dataRow.contactId, this.dataRow.statusColor,
      this.TODOupdate, this.communicationIdChat)
      .subscribe(data => {
        this.onSaveContact();
        this.webServiceCalls();
        this.updateTask(this.dataRow.id);
      }, error => {
        console.log(error);
      });

  }

  onSaveContact() {
    let sessionUserPartner = this.loginPartnerService.currentSessionValue;
    let taskId = this.dataRow.id;

    if (this.selectedPartner && this.selectedPartner.contactId) {
      let newContactId = this.selectedPartner.contactId;

      this.helpdeskService.setContact(sessionUserPartner, taskId, newContactId)
        .subscribe(
          response => {
            console.log('Contact updated successfully', response);
          },
          error => {
            console.error('Error updating contact', error);
          }
        );
    } else {
      console.error('No partner selected or selected partner does not have a contact ID');
    }
  }

  /* drag and drop files */

  onFileDropped($event) {
    this.toFileList($event);

  }

  fileBrowseHandler(files) {
    this.toFileList(files);
  }

  toFileList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
      this.filesCount = this.files.length;
    }

  }

  uploadFile(index: number) {

  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.filesCount = this.files.length;
  }

  showAddFile() {
    this.addFileShow = true;
  }

  descriptionSelected() {
    this.router.navigate(["/uredi-task/" + this.dataRow.id], { queryParams: { zavihek: 'description' } });
  }

  messagesSelected() {
    this.router.navigate(["/uredi-task/" + this.dataRow.id], { queryParams: { zavihek: 'messages' } });
    this.setMessageReadAll();
  }

  mailContentSelected() {
    this.webServiceMailCall();
    this.router.navigate(["/uredi-task/" + this.dataRow.id], { queryParams: { zavihek: 'mailContent' } });
  }

  filesSelected() {
    this.router.navigate(["/uredi-task/" + this.dataRow.id], { queryParams: { zavihek: 'files' } });
  }

  processesSelected() {
    this.router.navigate(["/uredi-task/" + this.dataRow.id], { queryParams: { zavihek: 'proccesses' } });
  }

  setTaskStatus(selectedStatus) {
    this.helpdeskService.setTaskStatus(
      this.mainService.currentUserValue, this.dataRow.text, this.dataRow.id, selectedStatus, this.dataRow.contactId, this.communicationIdChat).subscribe(data => {
        this.updateTask(this.dataRow.id);
      }, error => {
        console.log(error);
        this._snackbar.open(error.error.errorUser, '', {
          duration: 2000,
        });
      });
  }

  setData() {
    if (this.loginPartnerService.currentPartnerValue) {
      this.partnerLoggedIn = true;
      this.rowDataBasic = [
        //{position: 'Termin', name: this.dataRow.tsEvent},
        { position: 'Čas vnosa', name: this.dataRow.tsBooked },
        //{position: 'Naslednji kontakt', name: this.dataRow.nextContact},
        { position: 'Status', name: this.dataRow.statusNameSmall },
        //{position: 'V delu', name: this.dataRow.workFirstNameCurrent},
        { position: 'Tip komunikacije', name: this.dataRow.communicationTypeNameSmall },
        { position: 'To-do', name: this.dataRow.todoCode },

      ];
      this.rowDataPartner = [
        //{position: 'Ime', name: this.dataRow.workerName},
        //{position: 'Koda delavca', name: this.dataRow.workerCode},
        { position: 'Porabljene minute', name: this.dataRow.timespendMin },
        //{position: 'Odgovoril', name: this.dataRow.replied},
        { position: 'Sodelovanje', name: this.dataRow.cooperationNameSmall },
        //{position: 'Koda sodelovanja', name: this.dataRow.cooperationCode},
        //{position: 'BuildInSolution', name: this.dataRow.buildInSolution},
        { position: 'Partner', name: this.dataRow.partnerTitleSmall },
        { position: 'Število neprebranih sporočil', name: this.dataRow.numberOfUnreadMessages }
      ];
    } else {
      this.rowDataBasic = [
        { position: 'Termin', name: this.dataRow.tsEvent },
        { position: 'Čas vnosa', name: this.dataRow.tsBooked },
        { position: 'Naslednji kontakt', name: this.dataRow.nextContact },
        { position: 'Status', name: this.dataRow.statusNameSmall },
        { position: 'V delu', name: this.dataRow.workFirstNameCurrent },
        { position: 'Tip komunikacije', name: this.dataRow.communicationTypeNameSmall },
        { position: 'To-do', name: this.dataRow.todoCode },
        { position: 'Število neprebranih sporočil', name: this.dataRow.numberOfUnreadMessages },
      ];
      this.rowDataPartner = [
        { position: 'Ime', name: this.dataRow.workerName },
        { position: 'Koda delavca', name: this.dataRow.workerCode },
        { position: 'Porabljene minute', name: this.dataRow.timespendMin },
        { position: 'Odgovoril', name: this.dataRow.replied },
        { position: 'Sodelovanje', name: this.dataRow.cooperationNameSmall },
        { position: 'Koda sodelovanja', name: this.dataRow.cooperationCode },
        { position: 'BuildInSolution', name: this.dataRow.buildInSolution },
        { position: 'Partner', name: this.dataRow.partnerTitleSmall }
      ];
      console.log(this.dataRow);
      this.text = this.dataRow.text;
      this.partnerTitleSmallFilter.patchValue(this.dataRow.partnerTitleSmall)
    }
    this.dataSourceLeft = this.rowDataBasic;
    this.dataSourceRight = this.rowDataPartner;

  }
  updateTask(id) {
    this.helpdeskService.getHelpdeskTaskById(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
      this.loginPartnerService.currentPartnerValue, id).subscribe(data => {
        console.log(data);

        this.helpdeskService.changeDataRow(timeParserOneElement(data.data.tasks[0]));
        this.webServiceCalls();
        this.setData();
        this.dataSourceLeft = this.rowDataBasic;
        this.dataSourceRight = this.rowDataPartner;
      }, error => {
        console.log(error);
      });
  }


  onAmWorking() {
    this.helpdeskService.setCurrentWorker(this.mainService.currentUserValue, this.dataRow.id).subscribe(data => {
      this.updateTask(this.dataRow.id);
    }, error => {
      console.log(error);
      this._snackbar.open('S to vrstico, že morda nekdo upravlja. Osvežite stran in poskusite znova.', '', {
        duration: 2000,
      });
    });
  }

  onStopWorking() {
    this.helpdeskService.deleteCurrentWorker(this.mainService.currentUserValue, this.dataRow.id).subscribe(data => {
      this.updateTask(this.dataRow.id);

    }, error => {
      console.log(error);
      this._snackbar.open('S to vrstico, že morda nekdo upravlja. Osvežite stran in poskusite znova.', '', {
        duration: 2000,
      });
    });
  }

  setMessageReadAll() {
    this.helpdeskService.setMessageReadAll(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
      this.loginPartnerService.currentPartnerValue, this.dataRow.id).subscribe(data => {
      }, error => {
        console.log(error);
      });
  }

  hammerSwipe() {
    if (this.isMobile) {
      localStorage.setItem('tabContactId', this.dataRow.contactId.toString());
      this.router.navigate(['/helpdesk-tab']);
    }
  }
  statusTooltip(colorId) {
    return this.helperService.statusTooltip(colorId);
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      taskId: this.dataRow.id,
      taskText: this.dataRow.text
    };

    const dialogRef = this.dialog.open(DialogDodajDelavcaComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      this.updateTask(this.dataRow.id);
    });
  }

  refreshMessages() {
    this.messageViewChild.getMessages();
  }
}
